import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import "../css/ChangePassword.css";
import Vas from '../Vas';

import { ExtendedButton,TextField,Icon } from 'component-lib';
import { CheckPassword } from 'utils-lib';
import { RequestAjaxClass, PasswordModel,AccountsModel } from 'models-lib';

class ChangePassword  extends Component {

    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.OldPassword = "";
        this.state.NewPassword = "";
        this.state.RetypedNewPassword = "";
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.PasswordModel = new PasswordModel([this],null,this.Request);
        this.AccountsModel = new AccountsModel([this],null,this.Request);

        //Hier die Angaben zur Vertragsanlage löschen, da der Dokumentenupload ebenfalls erfolgreich war
        localStorage.removeItem("CustomerId");
        localStorage.removeItem("ContractNUmber");
        localStorage.removeItem("ExecutingForm");
    }

    componentDidMount(){
        this.Request.setAuth(true);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setErrorHandler(()=>{
            $("#LoadingIconPopUp").removeClass().addClass('hide');
        });
        this.PasswordModel.GetPaswordPolicy();

        this.setState({ requiredFields:[this.refs.oldPassword, this.refs.newPassword, this.refs.retypePassword] });
    }

    componentDidUpdate(){
        this.checkFields();
    }

    Update(observer)
    {
        let me = this;
        this.setState({},()=>{
            if(observer === "PaswordPolicy"){
                let length = me.PasswordModel.PasswordLength;
                let countNumbers = me.PasswordModel.CountMinNumbers;
                let countLetters = me.PasswordModel.CountMinLetters;
                let countLowerCaseLetters = me.PasswordModel.CountMinLowerCaseLetters;
                let countUpperCaseLetters = me.PasswordModel.CountMinUpperCaseLetters;
                let countSpecialCharacters = me.PasswordModel.CountMinSpecialCharacters;
                
                let text = "display";
                let lengthL = "hide";
                let numbers = "hide";
                let letters = "hide";
                let lowerCaseLetters = "hide";
                let upperCaseLetters = "hide";
                let characters = "hide";
                if (length > 0){
                    lengthL = "display";
                    text = "hide";
                }
                if (countNumbers > 0){
                    numbers = "display";
                    text = "hide";
                }
                if (countLetters > 0){
                    letters = "display";
                    text = "hide";
                }
                if (countLowerCaseLetters > 0){
                    lowerCaseLetters = "display";
                    text = "hide";
                }
                if (countUpperCaseLetters > 0){
                    upperCaseLetters = "display";
                    text = "hide";
                }
                if (countSpecialCharacters > 0){
                    characters = "display";
                    text = "hide";
                }
                ReactDOM.render(
                  <div>
                    <div className={text}>-</div>
                    <div className={lengthL}>{Vas.Resources.Labels["Least"]} {Vas.Resources.Labels["Length"]}: {length} {Vas.Resources.Labels["Chars"]}<br /></div>
                    <div className={numbers}>{Vas.Resources.Labels["Least"]} {countNumbers} {Vas.Resources.Labels["AtLeastNumbers"]}<br /></div>
                    <div className={letters}>{Vas.Resources.Labels["Least"]} {countLetters} {Vas.Resources.Labels["AtLeastChars"]}<br /></div>
                    <div className={lowerCaseLetters}>{Vas.Resources.Labels["Least"]} {countLowerCaseLetters} {Vas.Resources.Labels["AtLeastLowerChars"]}<br /></div>
                    <div className={upperCaseLetters}>{Vas.Resources.Labels["Least"]} {countUpperCaseLetters} {Vas.Resources.Labels["AtLeastUpperChars"]}<br /></div>
                    <div className={characters}>{Vas.Resources.Labels["Least"]} {countSpecialCharacters} {Vas.Resources.Labels["AtLeastSymbols"]}<br /></div>
                  </div>
                ,document.getElementById("policy"));
                me.setState({ PasswordModus:[length,countNumbers,countLetters,countLowerCaseLetters,countUpperCaseLetters,countSpecialCharacters] });
            }
            else if(observer === "ChangePassword"){
                localStorage.setItem('vas_token',me.PasswordModel.Token);
                $("#LoadingIconPopUp").removeClass().addClass('hide');
                
                me.AccountsModel.Own();
            }
            else if(observer === "AccountsOwn"){
                localStorage.setItem("vas_customerId", me.AccountsModel.Customer.Id);
                Vas.GetView("ChangePasswordSuccess",null,true);
            }
        });
    }

    checkFields(){
        if (this.state.requiredFields){

            if (document.getElementById(this.refs.oldPassword.props.Id).value !== document.getElementById(this.refs.newPassword.props.Id).value) {
                $("#error1").removeClass().addClass("hide");
            }

            if(document.getElementById(this.refs.retypePassword.props.Id).value !== document.getElementById(this.refs.newPassword.props.Id).value) {
                $("#error2").removeClass().addClass("hide");
            }

            let count=this.state.requiredFields.length;
            let filled=0;

            for (let i=0;i<this.state.requiredFields.length;i++){
                if (this.state.requiredFields[i]){
                    if (document.getElementById(this.state.requiredFields[i].props.Id).value.length>0){
                            filled++;
                    }
                }
            }
            if (filled < count){
                this.refs.btoChange.setState({ usable:false });
            } else {

                this.refs.btoChange.setState({ usable:false });
                
                if(document.getElementById(this.refs.retypePassword.props.Id).value 
                  == document.getElementById(this.refs.newPassword.props.Id).value) {

                  $("#error2").removeClass().addClass("hide");

                  if(this.refs.IconPassword.state.Name == "Done") {
                    this.refs.btoChange.setState({ usable:true });
                  } 
                } else {
                    $("#error2").removeClass().addClass("show");
                }

                if (document.getElementById(this.refs.oldPassword.props.Id).value == document.getElementById(this.refs.newPassword.props.Id).value) {
                    $("#error1").removeClass().addClass("show");
                    this.refs.btoChange.setState({ usable:false });
                }
            }
        }
    }

    ChangePassword(){
        $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
    
        this.setState({ OldPassword:document.getElementById("oldPassword").value, NewPassword:document.getElementById("newPassword").value,RetypedNewPassword:document.getElementById("retypePassword").value }, ()=>{
            this.PasswordModel.ChangePassword(this.state.OldPassword,this.state.NewPassword);
        });
    }

    Close(){
        ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        $("#Content").css("opacity", "1");
    }

    CheckPassword(){

        if (document.getElementById(this.refs.newPassword.props.Id).value.length > 0){
            if (CheckPassword.Check(document.getElementById(this.refs.newPassword.props.Id).value,this.state.PasswordModus) === true){
                this.refs.IconPassword.setState({ Name:"Done",Color:"green" });
            } else {
                this.refs.IconPassword.setState({ Name:"Warning",Color:"red" });
            }
        } else {
            this.refs.IconPassword.setState({ Name:"Warning",Color:"red" });
        }

        if (document.getElementById(this.refs.oldPassword.props.Id).value == document.getElementById(this.refs.newPassword.props.Id).value) {
            $("#error1").removeClass().addClass("show");
        } else {
            $("#error1").removeClass().addClass("hide");
        }
    }

    render()
    {
        return (
        <div className={"form changePasswordForm"} style={{width:"300px"}}>
            <div>
                <table>
                    <thead>
                        <tr>
                            <th colSpan={2}>{Vas.Resources.Labels["ChangePassword"]}</th>
                            <th><div
                                id={"LoadingIcon"}
                                className={'hide'}></div></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td colSpan={2}><TextField 
                            AppURL={Vas.ApplicationUrl} 
                            Id="oldPassword" 
                            ref={"oldPassword"} 
                            name="oldPassword" 
                            Type={"password"} 
                            Editable={true} 
                            IsRequired={true} 
                            Label={Vas.Resources.Labels["CurrentPassword"]} 
                            OnBlur={(e,val)=>{ this.setState({ OldPassword: val });}}
                            Width={250}  />
                            <br />
                        </td></tr>
                        <tr><td colSpan={2}><TextField 
                            AppURL={Vas.ApplicationUrl} 
                            Id="newPassword" 
                            ref={"newPassword"} 
                            name="newPassword" 
                            Type={"password"} 
                            Editable={true} 
                            IsRequired={true} 
                            Label={Vas.Resources.Labels["NewPassword"]} 
                            OnBlur={(e,value)=>{ this.setState( { NewPassword: value });}} 
                            OnChange={()=>{this.CheckPassword();}}
                            Width={230} />
                            <Icon 
                                ref={"IconPassword"} 
                                Name={"Warning"} 
                                Size={24} 
                                Color={"red"} 
                                Align={"left"} />
                            <br />
                        </td></tr>
                        <tr><td colSpan={2}><TextField  
                            AppURL={Vas.ApplicationUrl} 
                            Id="retypePassword" 
                            ref={"retypePassword"} 
                            name="retypePassword" 
                            Type={"password"} 
                            Editable={true} 
                            IsRequired={true} 
                            Label={Vas.Resources.Labels["NewPassword2"]}
                            OnChange={(e,value)=>{ this.setState( { RetypedNewPassword: value });}}
                            Width={250}  />
                        </td></tr>
                        <tr><td colSpan={2} 
                        id={"error1"} 
                        className={"hide"}>{Vas.Resources.Labels["PasswordOldNew"]}
                        </td></tr>
                        <tr><td colSpan={2}
                        id={"error2"} 
                        className={"hide"}>{Vas.Resources.Labels["PasswordNotMatch"]}
                        </td></tr>
                        <tr><td colSpan={2}
                        className={"ConfirmationLabel"}>{Vas.Resources.Labels["PasswordPolicy"]} 
                        </td></tr>
                        <tr><td colSpan={2}
                        id={"policy"} 
                        className={"ConfirmationLabel"}></td></tr>
                        <tr><td colSpan={2}
                        id={"error3"} 
                        className={"hide"}>{Vas.Resources.Labels["PasswordSave"]}
                        </td></tr>
                        <tr><td>
                            <ExtendedButton 
                                Usable={false} 
                                ref={"btoChange"} 
                                Text={Vas.Resources.Labels["ChangePassword"]} 
                                OnClick={()=>{ this.ChangePassword();}} 
                                style={{ margin: 25 }} 
                                Width={125} 
                                />
                            </td>
                            <td>
                            <ExtendedButton
                                Usable={true}
                                Text={Vas.Resources.Labels["Cancel"]}
                                Float={'left'}
                                OnClick={()=>{  Vas.GetView('Account',null,true);}}
                                Width={125}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
          </div>
        </div>
        
        );
    }
}
export default ChangePassword;
